import { Box, Flex, H3, H4, Spinner } from '@ouster/webviz-react-components';

export const StatisticBox = ({
  label,
  value,
  loading = false,
}: {
  label: string;
  value: string;
  loading?: boolean;
}) => (
  <Box
    flexGrow={1}
    display="grid"
    rowGap="4px"
    data-testid={`statistic-box-${label.toLowerCase().replace(/\s/g, '-')}`}
  >
    <H4 color="var(--color-unify-white-80)" fontSize="xs" width="max-content">
      {label ?? ''}
    </H4>
    <Box fontWeight={500} fontSize="1.5rem">
      {loading ? (
        <Box h={30} display="flex" alignItems="center">
          <Spinner />
        </Box>
      ) : (
        value
      )}
    </Box>
  </Box>
);

export const StatisticGroup = ({
  title,
  stats,
}: {
  title: string;
  stats: { label: string; value: string; loading?: boolean }[];
}) => (
  <Box
    p="1rem"
    border="1px solid var(--color-unify-white-40)"
    borderRadius={8}
    minW={48}
    data-testid="statistic-group"
  >
    <H3
      fontSize={18}
      data-testid="statistic-group-title"
      mb={6}
      width="fit-content"
    >
      {title}
    </H3>
    <Flex flexDirection="column" gap={8}>
      {stats.map((stat) => (
        <StatisticBox
          key={stat.label}
          label={stat.label}
          value={stat.value}
          loading={stat.loading}
        />
      ))}
    </Flex>
  </Box>
);
